<div class="container-filter__padding" style="overflow: hidden">
  <mat-radio-group>
    <div class="item-filter">
      <div class="lista">
        <span class="order-by">Ordernar por</span>
        <div style="margin-top: 5px"></div>
        @for(option of options; track option){
        <div class="item">
          <mat-radio-button
            class="filter-radio-margin"
            disableRipple
            color="primary"
            [checked]="option.value === orderBy"
            [value]="option.value"
            labelPosition="before"
            (click)="onRadioClick($event, option.value)"
          >
            <div
              style="
                position: absolute;
                width: 90%;
                height: 10%;
                cursor: pointer;
              "
            ></div>
            <span
              class="filter-text"
              style="cursor: pointer; white-space: nowrap"
              >{{ option.label }}</span
            >
          </mat-radio-button>
        </div>
        }
      </div>
    </div>
  </mat-radio-group>
</div>
